import React from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, Package } from 'lucide-react';

const VendorBookingWidget = ({ vendor, services, minPrice }) => {
  const cheapestService = services.length > 0 ? services.reduce((prev, current) => 
    (prev.base_price || 0) < (current.base_price || 0) ? prev : current
  ) : null;

  const vendorRating = Number(vendor?.average_rating) || 0;
  const vendorReviews = Number(vendor?.total_reviews) || 0;

  return (
    <div className="border border-gray-200 rounded-xl p-6 bg-white shadow-lg">
      {/* Price */}
      <div className="mb-6">
        <div className="flex items-baseline gap-2">
          <span className="text-2xl font-light text-black">
            ${minPrice ? minPrice.toFixed(2) : cheapestService?.base_price || 'Contact'}
          </span>
          {services.length > 0 && minPrice && (
            <span className="text-base text-gray-600 font-light">starting price</span>
          )}
        </div>
      </div>

      {/* Service Summary */}
      {services.length > 0 && (
        <div className="mb-6 p-4 border border-gray-200 rounded-lg space-y-3">
          <div className="flex items-center justify-between pb-3 border-b border-gray-200">
            <span className="text-sm font-light text-gray-600">Services</span>
            <div className="flex items-center gap-1">
              <Package className="w-4 h-4 text-gray-600" />
              <span className="text-sm font-medium text-black">{services.length} available</span>
            </div>
          </div>
          <div className="text-sm text-gray-700 font-light">
            Browse services to view pricing and book
          </div>
        </div>
      )}

      {/* CTA Button */}
      <Link
        to={cheapestService ? `/services/${cheapestService.id}` : '#'}
        className="block w-full py-4 px-4 bg-black text-white text-center rounded-lg font-light hover:bg-gray-800 transition-colors mb-4"
      >
        {services.length > 0 ? 'View Services' : 'Contact Vendor'}
      </Link>

      <p className="text-xs text-center text-gray-500 font-light mb-6">
        You won't be charged yet
      </p>

      {/* Details Section */}
      <div className="pt-6 border-t border-gray-200">
        <div className="space-y-4 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-gray-600 font-light">Starting Price</span>
            <span className="font-light text-black">
              ${minPrice ? minPrice.toFixed(2) : 'Contact'}
            </span>
          </div>

          {services.length > 0 && (
            <div className="flex items-center justify-between">
              <span className="text-gray-600 font-light">Services Available</span>
              <div className="flex items-center gap-1">
                <Package className="w-4 h-4 text-gray-600" />
                <span className="font-light text-black">{services.length}</span>
              </div>
            </div>
          )}

          {vendorRating > 0 && (
            <div className="flex items-center justify-between">
              <span className="text-gray-600 font-light">Rating</span>
              <div className="flex items-center gap-1">
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                <span className="font-light text-black">
                  {typeof vendorRating === 'number' && !isNaN(vendorRating) ? vendorRating.toFixed(1) : '0.0'}
                  {vendorReviews > 0 && (
                    <span className="text-gray-500 ml-1">
                      ({vendorReviews})
                    </span>
                  )}
                </span>
              </div>
            </div>
          )}

          {vendor?.city && vendor?.state && (
            <div className="flex items-center justify-between">
              <span className="text-gray-600 font-light">Location</span>
              <div className="flex items-center gap-1">
                <MapPin className="w-4 h-4 text-gray-600" />
                <span className="font-light text-black">
                  {vendor.city}, {vendor.state}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Report Listing */}
      <div className="pt-6 border-t border-gray-200">
        <button className="w-full text-sm font-light text-black underline text-center hover:text-gray-600 transition-colors">
          Report this listing
        </button>
      </div>
    </div>
  );
};

export default VendorBookingWidget;

